import React from 'react';
import InputTypesEnum from '../../../Enums/InputTypesEnum';
import ValidityHelper from '../../../Helpers/ValidityHelper';
import OutsourcedIOBLineItemDetailService from '../../../Services/OutsourcedIOBLineItemDetailService';
import dateTimeHelper from '../../../Helpers/datetimeHelper';

class RepeatOutsourcedIOBLineItemDetailWindowDescription extends React.Component {
  static titleForEdit = 'Repeat Outsourced IOB Line Item Detail';

  static serviceFunction = (editedItem) => OutsourcedIOBLineItemDetailService.Repeat(editedItem);

  static pagesInGeneralEditWizzard = [
    {
      label: 'Repeat',
      fields: [
        {
          fieldName: 'PeriodMonth',
          label: 'Repeat Period',
          className: 'col-4',
          type: InputTypesEnum.Select,
          selectvalues: RepeatOutsourcedIOBLineItemDetailWindowDescription.getSelectValuesForRepeatPeriod,
          onFieldChange: RepeatOutsourcedIOBLineItemDetailWindowDescription.onRepeatPeriodChange,
          validityChecker: ValidityHelper.forRequiredSelectField,
        },
        {
          fieldName: 'StartDate',
          label: 'Start Date',
          className: 'col-4',
          type: InputTypesEnum.Date,
          onFieldChange: RepeatOutsourcedIOBLineItemDetailWindowDescription.onRepeatPeriodChange,
          validityChecker: ValidityHelper.forRequiredTextField,
        },
        {
          fieldName: 'EndDate',
          label: 'End Date',
          className: 'col-4',
          type: InputTypesEnum.Date,
          onFieldChange: RepeatOutsourcedIOBLineItemDetailWindowDescription.onRepeatPeriodChange,
          validityChecker: ValidityHelper.forRequiredTextField,
        },
        {
          fieldName: 'ExpectedRepeats',
          label: 'Expected Number of Repeats',
          className: 'col-4',
          type: InputTypesEnum.TextBoxReadOnly,
          validityChecker: ValidityHelper.AlwaysFlawless,
        },
      ],
    },
  ];

  static getSelectValuesForRepeatPeriod() {
    return [
      { label: 'Monthly', value: 1, disabled: false },
      { label: 'Bimonthly', value: 2, disabled: false },
      { label: 'Quarterly', value: 3, disabled: false },
    ];
  }

  static onRepeatPeriodChange(item) {
    const repeatPeriod = item.PeriodMonth;
    const startDate = new Date(dateTimeHelper.toYYYYsMMsDD(item.StartDate));
    const endDate = new Date(dateTimeHelper.toYYYYsMMsDD(item.EndDate));

    if (startDate > endDate) {
      item.ExpectedRepeats = '';
      return;
    }

    let currentDate = startDate;
    let expectedRepeats = '';
    let repeatCount = 0;
    do {
      expectedRepeats += !expectedRepeats
        ? `${dateTimeHelper.toYYYYsMMsDD(currentDate)}`
        : `\n${dateTimeHelper.toYYYYsMMsDD(currentDate)}`;
      repeatCount++;
      currentDate = dateTimeHelper.addMonthsToDate(currentDate, repeatPeriod);
    } while (currentDate <= endDate);

    expectedRepeats += `\nTotal: ${repeatCount}`;
    item.ExpectedRepeats = expectedRepeats;
  }
}

export default RepeatOutsourcedIOBLineItemDetailWindowDescription;
